/* wsapi3-login-page v1.0 */
/* Deploy Version 2026-10-14 10:42:32 */
/* Deploy Version 2026-09-24 19:11:11 */
/* Deploy Version 2026-08-10 */
(function () {
  function getReturnTo() {
    try {
      const val = new URLSearchParams(window.location.search).get('return_to') || '';
      // Aceita apenas URLs relativas para evitar open redirect
      return val && val.startsWith('/') ? val : '';
    } catch { return ''; }
  }

  function redirectAfterLogin() {
    window.location.href = getReturnTo() || '/minha-conta';
  }

  function init() {
    if (ApiWS.User.isValid()) {
      redirectAfterLogin();
      return;
    }

    const flow = WsIdentifyFlow.create({
      els: {
        identityRow: '#id-identity-row',
        identityInput: '#id-identity-input',
        displayRow: '#id-identity-display-row',
        displayValue: '#id-identity-display-value',
        changeIdentityLink: '#id-change-identity-link',
        passwordField: '#id-password-field',
        passwordRow: '#id-password-row',
        passwordInput: '#id-password-input',
        continueBtn: '#id-continue-btn',
        continueLabel: '#id-continue-label',
        mainMsg: '#id-main-msg',
        title: '#id-main-title',
        subtitle: '#id-subtitle',
        googleBtn: '#id-google-btn',
        facebookBtn: '#id-facebook-btn',
        forgotLink: '#id-forgot-link',
        screenMain: '#id-screen-main',
        screenForgot: '#id-screen-forgot',
        forgotEmail: '#id-forgot-email',
        forgotMsg: '#id-forgot-msg',
        forgotSendBtn: '#id-forgot-send-btn',
        forgotBackBtn: '#id-forgot-back-btn',
        screenVerify: '#id-screen-verify',
        verifyEmailLabel: '#id-verify-email-label',
        verifyCode: '#id-verify-code',
        verifyMsg: '#id-verify-msg',
        verifyBtn: '#id-verify-btn',
        verifyBackBtn: '#id-verify-back-btn',
        screenReset: '#id-screen-reset',
        resetPassword: '#id-reset-password',
        resetPasswordConfirm: '#id-reset-password-confirm',
        resetMsg: '#id-reset-msg',
        resetBtn: '#id-reset-btn',
      },
      moveButton: true,
      socialSignupFallback: true,
      // Pré-preenche e-mail vindo de ?email= (ex: redirecionado do checkout)
      prefillIdentityFromQuery: 'email',

      onIdentityNew(identity) {
        let target = '/cadastro';
        if (identity && identity.type === 'email') target += '?email=' + encodeURIComponent(identity.value);
        window.location.href = target;
      },
      onLoginSuccess() {
        redirectAfterLogin();
      },
      onSocialSignupResolved(provider, data) {
        let target = '/cadastro?email=' + encodeURIComponent(data.email) + '&social=' + encodeURIComponent(provider);
        if (data.name) target += '&name=' + encodeURIComponent(data.name);
        window.location.href = target;
      },
    });

    flow.init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
